/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePromotionManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './modulePromotionManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_POPUP (state,popup){
      state.popup = popup;
    },
    SET_PROMOTION (state,promotion){
      state.promotion = promotion;
    },
    SET_PROMOTIONS (state,promotions){
      state.promotions = promotions;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    company: (state) => state.company,
    department: (state) => state.department,
  },
}

